export const secondsToHours = (seconds: number) => {
  return seconds / 60 / 60;
};

export function debounce(func, ref, timeout) {
  if (ref.debounceTimer) clearTimeout(ref.debounceTimer);
  ref.debounceTimer = setTimeout(() => func(...arguments), timeout || 100);
}
